import request from '@/utils/request'

let WelfareApi = {
    /*获取福利金列表*/
    GetUserList(data) {
        return request._get('/shop/plus.welfare.Index/index', data);
    },
    saveSetting(data, errorback) {
        return request._post('/shop/plus.welfare.Setting/getSetting', data, errorback);
      },
    getSetting(data, errorback) {
        return request._get('/shop/plus.welfare.Setting/getSetting', data, errorback);
      },
      
}
export default WelfareApi;



// WEBPACK FOOTER //
// ./src/api/welfare.js